<!-- ======================== Contact ======================== -->

<section class="page">

    <!-- ===  Page header === -->

    <div class="page-header" style="background-image:url(assets/images/header-1.jpg)">
        <div class="container">
            <h2 class="title">IMPORTANT INFORMATION</h2>
            <p>Please note the following information about the conference</p>
        </div>
    </div>

    <!-- ===  Contact === -->

    <div class="contact">

        <div class="container">

            <!-- === Google map === -->

            <div class="map" id="map"></div>

            <div class="row">

                <div class="col-sm-10 col-sm-offset-1 col-md-10 col-md-offset-1">

                    <!-- === Contact block === -->

                    <div class="contact-block">
                        <div>
                            <h2 class="text-center">IMPORTANT INFORMATION</h2>
                            <div>
                                <h3>Discounted Air Fares:</h3>
                                <p>As the official accommodation partner to Empowered21, we have also been able to negotiate
                                    special discounted air fares with major airlines. Please contact us for a quote if you
                                    are interested in these fares. Thank you.
                                </p>
                            </div>
                            <div>
                                <h3>Your Specified Hotels:</h3>
                                <p>
                                    After payment is made for accommodation, you will have access to print confirmation letters for each booking you have made.
                                    A follow-up email with details of the hotels of your choice will be sent to you in a
                                    due course. You can however use this confirmation letter for your visa acquisition if
                                    applicable.
                                </p>
                            </div>
                            <div>
                                <h3>After Payment is made:</h3>
                                <p>
                                    Note that, once payment for either accommodation or conference is made, you can't add additional booking or delete existing
                                    one. You will have to log out, and create a new user account to add more bookings.
                                </p>
                            </div>
                        </div>
                        <!-- === Contact banner === -->

                        <div class="banner">
                            <div class="row">
                                <div class="col-md-offset-1 col-md-10 text-center">
                                    <h3 class="title">Send Queries</h3>
                                    <p>
                                        If you have any queries, please send them to
                                        <br /> info@charlitex.com
                                    </p>

                                </div>
                            </div>
                        </div>

                        <!-- === Contact info === -->

                        <div class="contact-info">
                            <div class="row">
                                <div class="col-sm-4">
                                    <figure class="text-center">
                                        <span class="icon icon-map-marker"></span>
                                        <figcaption>
                                            <strong>Where are we?</strong>
                                            <span>136 Commissioner Street,
                                                <br />Kempton Park, Johannesburg</span>
                                        </figcaption>
                                    </figure>
                                </div>
                                <div class="col-sm-4">
                                    <figure class="text-center">
                                        <span class="icon icon-phone"></span>
                                        <figcaption>
                                            <strong>Call us</strong>
                                            <span>
                                                <strong>T</strong> +27 11 975 3210
                                                <br />
                                                <strong>T</strong> +27 78 878 6023
                                                <br />
                                                <strong>T</strong> +27 78 739 1084
                                                <br />
                                                <strong>T</strong> +27 81 584 8326
                                            </span>
                                        </figcaption>
                                    </figure>
                                </div>
                                <div class="col-sm-4">
                                    <figure class="text-center">
                                        <span class="icon icon-clock"></span>
                                        <figcaption>
                                            <strong>Working hours</strong>
                                            <span>
                                                <strong>Mon</strong> - Fri: 7 am - 7 pm
                                                <br />
                                                <strong>Sat</strong> 7 am - 5 pm
                                                <br />
                                                <strong>Sun</strong> 7 am - 5 pm
                                            </span>
                                        </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </div>

                    </div>
                    <!--/contact-block-->
                </div>
                <!--col-sm-8-->
            </div>
            <!--/row-->
        </div>
        <!--/container-->
    </div>
    <!--/contact-->
</section>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/core/components/contact/contact.component.html